/* tslint:disable */
/* eslint-disable */
/**
 * B2B Purchase
 * General interface for purchasing products  # Tracking Metrics * `b2bportal.booking.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.booking.payment.failure`   * tags: `api_version`, `payment`, `tenantid` * `b2bportal.booking.payment.success`   * tags: `api_version`, `payment`, `tenantid` * `b2bportal.booking.product.failure`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.booking.product.success`   * tags: `api_version`, `product`, `tenantid` * `b2bportal.booking.success`   * tags: `api_version`, `tenantid` * `b2bportal.mytrips.get_trip_access_token.failure`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.mytrips.get_trip_access_token.success`   * tags: `api_version`, `product`, `tenantid` * `b2bportal.quote.failure`   * tags: `api_version`, `error_code`, `quote_action`, `tenantid` * `b2bportal.quote.payment.failure`   * tags: `api_version`, `error_code`, `payment`, `quote_action`, `tenantid` * `b2bportal.quote.payment.success`   * tags: `api_version`, `payment`, `quote_action`, `tenantid` * `b2bportal.quote.product.failure`   * tags: `api_version`, `error_code`, `product`, `quote_action`, `tenantid` * `b2bportal.quote.product.success`   * tags: `api_version`, `product`, `quote_action`, `tenantid` * `b2bportal.quote.success`   * tags: `api_version`, `quote_action`, `tenantid`   # Tracking Error Codes * `application_error` * `auth_error` * `bad_request` * `cart_validation_error` * `discount_error` * `expired_fulfill_token` * `expired_quote_token` * `fraud_auto_reject` * `in_activity` * `internal_error` * `invalid_session` * `no_availability` * `no_payments_provided` * `non_distinct_payments` * `payment_error` * `product_error` * `request_deserialization_error` * `response_serialization_error` * `unknown` * `user_not_found`  # Tracking Error Codes * `deleted_user` * `trip_not_found` * `unknown`
 *
 * The version of the OpenAPI document: v1p81
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

export interface APaymentError {
    'value': PaymentOpaqueValue;
}
export interface AProductError {
    'value': ProductOpaqueValue;
}
export interface AccountPrice {
    'currency': string;
    'value': number;
    'currencyDescription'?: string;
}
/**
 * List of payments to add to quote
 * @export
 * @interface AddPaymentsRequest
 */
export interface AddPaymentsRequest {
    'payments': Array<PaymentOpaqueValue>;
}
/**
 * List of product to add to quote
 * @export
 * @interface AddProductsRequest
 */
export interface AddProductsRequest {
    /**
     * An email address that matches given regex pattern. The frontend should validate the emails address since the request will fail if it doesn't match the pattern
     * @type {string}
     * @memberof AddProductsRequest
     */
    'emailAddress': string;
    'products': Array<ProductOpaqueValue>;
}
/**
 * Deprecated. Use Seat Product instead

* `CFAR` - Quote value maps to com.hopper.cfar.quote.QuoteId in Tysons
* `Seats` - Deprecated. Use Seat Product instead
 * @export
 * @enum {string}
 */

export const Ancillary = {
    CFAR: 'CFAR',
    Seats: 'Seats'
} as const;

export type Ancillary = typeof Ancillary[keyof typeof Ancillary];


/**
 * Model used to generify shared types across any product or payment type. The type of `OpaqueValue`
is a shared value between the FE and BFF. As a result each implementation of the purchase interface
can use different products/payments or even different versions of products or payments.
 * @export
 * @interface AncillaryOpaqueValue
 */
export interface AncillaryOpaqueValue {
    'type': Ancillary;
    'value': any;
}


export interface AuthError {
    'Error': PurchaseErrorEnum;
}


/**
 * A key used to look up a booking. The last name and confirmation id for a booking (e.g. flight locator)

 * `lastName` - The last name the person who booked the trip
 * @export
 * @interface ByLastNameAndConfirmationId
 */
export interface ByLastNameAndConfirmationId {
    /**
     * The last name the person who booked the trip
     * @type {string}
     * @memberof ByLastNameAndConfirmationId
     */
    'lastName': string;
    'customerConfirmationId': CustomerConfirmationId;
    'TripKey': TripKeyEnum;
}


export interface CartValidationError {
    'message': string;
    'Error': PurchaseErrorEnum;
}


/**
 * Encrypted text that has the trait that is non-fungible by client parties. `CipherText` can
only be read by the signing authority, the bff so sessions cannot be accessed by outside parties.
 * @export
 * @interface CipherText
 */
export interface CipherText {
    'value': string;
}
export interface CompleteInteractiveAuthRequest {
    'token': CipherText;
    'results': Array<PaymentAuthActionOpaqueValue>;
}
/**
 * @type CompleteInteractiveAuthResponse
 * @export
 */
export type CompleteInteractiveAuthResponse = { CompleteInteractiveAuthResponse: 'Failure' } & Failure | { CompleteInteractiveAuthResponse: 'Success' } & Success;

export const CompleteInteractiveAuthResponseEnum = {
    Failure: 'Failure',
    Success: 'Success'
} as const;

export type CompleteInteractiveAuthResponseEnum = typeof CompleteInteractiveAuthResponseEnum[keyof typeof CompleteInteractiveAuthResponseEnum];


/**
 * Details related to corporate travel models. May be safely ignored by other tenants.
 * @export
 * @interface CorporateTravel
 */
export interface CorporateTravel {
    'policyCompliance': PolicyCompliance;
}
/**
 * The user facing customer confirmation id for a booking (e.g. flight locator)
 * @export
 * @interface CustomerConfirmationId
 */
export interface CustomerConfirmationId {
    'product': Product;
    'id': string;
}


/**
 * Trip belongs to a deleted user
 * @export
 * @interface DeletedUser
 */
export interface DeletedUser {
    'GetTripAccessTokenResponse': GetTripAccessTokenResponseEnum;
}


export interface ErrorCode {
    'code': string;
    'cause'?: string;
    'message'?: string;
    'Error': PurchaseErrorEnum;
}


export interface ExpiredFulfillToken {
    'Error': PurchaseErrorEnum;
}


export interface ExpiredQuoteToken {
    'Error': PurchaseErrorEnum;
}


export interface FailedPayment {
    'id': PaymentId;
    'errors': Array<APaymentError>;
}
export interface FailedProduct {
    'id': ProductId;
    'errors': Array<AProductError>;
}
export interface Failure {
    'errors': Array<PurchaseError>;
    'CompleteInteractiveAuthResponse': CompleteInteractiveAuthResponseEnum;
}


/**
 * A cash amount
 * @export
 * @interface FiatPrice
 */
export interface FiatPrice {
    'currencyCode': string;
    'currencySymbol': string;
    'value': number;
}
export interface FraudAutoReject {
    'Error': PurchaseErrorEnum;
}


export interface FulfillFailure {
    'errors': Array<PurchaseError>;
    'FulfillResponse': FulfillResponseEnum;
}


export interface FulfillFailureV0 {
    'errors': Array<PurchaseError>;
    'FulfillResponse': FulfillResponseV0Enum;
}


export interface FulfillPending {
    'FulfillResponse': FulfillResponseEnum;
}


export interface FulfillPendingInteractivePaymentAuth {
    'token': CipherText;
    'actions': Array<PaymentAuthActionOpaqueValue>;
    'FulfillResponse': FulfillResponseEnum;
}


export interface FulfillPendingV0 {
    'FulfillResponse': FulfillResponseV0Enum;
}


/**
 * `prepareFulfillmentDetails` - Certain products may require additional information after quote to allow fulfillment
 * `corporateOutOfPolicyReason` - Max char length 256 - CaponeCorporate field. Used for travelers to let their admin know why they are booking an out of policy trip.
 * @export
 * @interface FulfillRequest
 */
export interface FulfillRequest {
    'quoteToken': CipherText;
    'payments': Array<PaymentOpaqueValue>;
    /**
     * Certain products may require additional information after quote to allow fulfillment
     * @type {Array<ProductOpaqueValue>}
     * @memberof FulfillRequest
     */
    'prepareFulfillmentDetails'?: Array<ProductOpaqueValue>;
    /**
     * Max char length 256 - CaponeCorporate field. Used for travelers to let their admin know why they are booking an out of policy trip.
     * @type {string}
     * @memberof FulfillRequest
     */
    'corporateOutOfPolicyReason'?: string;
}
/**
 * Deprecated. Use V1.FulfillRequest instead

 * `corporateOutOfPolicyReason` - Max char length 256 - CaponeCorporate field. Used for travelers to let their admin know why they are booking an out of policy trip.
 * `corporateBusinessId` - String - UUID - CaponeCorporate business ID attached to the booking
 * @export
 * @interface FulfillRequestV0
 */
export interface FulfillRequestV0 {
    /**
     * Max char length 256 - CaponeCorporate field. Used for travelers to let their admin know why they are booking an out of policy trip.
     * @type {string}
     * @memberof FulfillRequestV0
     */
    'corporateOutOfPolicyReason'?: string;
    'payments': Array<PaymentOpaqueValue>;
    'ancillaries': Array<AncillaryOpaqueValue>;
    /**
     * String - UUID - CaponeCorporate business ID attached to the booking
     * @type {string}
     * @memberof FulfillRequestV0
     */
    'corporateBusinessId'?: string;
    'quoteToken': CipherText;
}
/**
 * @type FulfillResponse
 * @export
 */
export type FulfillResponse = { FulfillResponse: 'Failure' } & FulfillFailure | { FulfillResponse: 'Pending' } & FulfillPending | { FulfillResponse: 'PendingInteractivePaymentAuth' } & FulfillPendingInteractivePaymentAuth | { FulfillResponse: 'Success' } & FulfillSuccess;

export const FulfillResponseEnum = {
    Failure: 'Failure',
    Pending: 'Pending',
    PendingInteractivePaymentAuth: 'PendingInteractivePaymentAuth',
    Success: 'Success'
} as const;

export type FulfillResponseEnum = typeof FulfillResponseEnum[keyof typeof FulfillResponseEnum];


/**
 * @type FulfillResponseV0
 * @export
 */
export type FulfillResponseV0 = { FulfillResponse: 'Failure' } & FulfillFailureV0 | { FulfillResponse: 'Pending' } & FulfillPendingV0 | { FulfillResponse: 'Success' } & FulfillSuccessV0;

export const FulfillResponseV0Enum = {
    Failure: 'Failure',
    Pending: 'Pending',
    Success: 'Success'
} as const;

export type FulfillResponseV0Enum = typeof FulfillResponseV0Enum[keyof typeof FulfillResponseV0Enum];


export interface FulfillSuccess {
    'products': Array<ProductOpaqueValue>;
    'payments': Array<PaymentOpaqueValue>;
    'trackingProperties': TrackingProperties;
    'FulfillResponse': FulfillResponseEnum;
}


export interface FulfillSuccessV0 {
    'fulfillment': ProductOpaqueValue;
    'FulfillResponse': FulfillResponseV0Enum;
}


/**
 * Request an access token for a trip purchased by a guest. The access token allows the user to view trip details and perform post-booking operations on the trip
 * @export
 * @interface GetTripAccessTokenRequest
 */
export interface GetTripAccessTokenRequest {
    'key': TripKey;
}
/**
 * @type GetTripAccessTokenResponse
 * The result of a GetTripAccessToken request
 * @export
 */
export type GetTripAccessTokenResponse = { GetTripAccessTokenResponse: 'DeletedUser' } & DeletedUser | { GetTripAccessTokenResponse: 'TripFound' } & TripFound | { GetTripAccessTokenResponse: 'TripNotFound' } & TripNotFound;

export const GetTripAccessTokenResponseEnum = {
    DeletedUser: 'DeletedUser',
    TripFound: 'TripFound',
    TripNotFound: 'TripNotFound'
} as const;

export type GetTripAccessTokenResponseEnum = typeof GetTripAccessTokenResponseEnum[keyof typeof GetTripAccessTokenResponseEnum];


export interface InActivity {
    'Error': PurchaseErrorEnum;
}


export interface InvalidSession {
    'Error': PurchaseErrorEnum;
}


export interface NoAvailability {
    'Error': PurchaseErrorEnum;
}


export interface NoPaymentsProvided {
    'Error': PurchaseErrorEnum;
}


export interface NonDistinctPayments {
    'Error': PurchaseErrorEnum;
}


/**
 * `Payment` types require shared, known types between client and server. `OpaqueValue`
is used to serialize and deserialize models related to specific `Payment`, but avoid coupling
this purchase interface to the specific `Payment` implementation.

### Attributes
 * `PaymentModel.Create` **required**
 *    Request model used to add the payment to an order during checkout.
 * `PaymentModel.Authorize` **optional**
 *    Request model used to fulfill a payment challenge during the 

 * PaymentModel.Quoted **optional** 
 *    Model displayed for payments added prior to "Confirm and Book" shown in the "Payment Breakdown".

 * PaymentModel.ListView - **required** 
 *    Model used to display charged amount on confirmation page, my trips, or any other post-booking display.
 * PaymentModel.Error - **required** 
 *    Error model when processing the payment.

* `AirChfarExerciseDiscount` - Representation of a discount from exercising a Chfar on a new flight.\n
    Interface defined in `b2b-interfaces/air-chfar`.
* `AirPriceFreezeExerciseDiscount` - Representation of the discount price delta from exercising a price freeze on a frozen flight.\n
    Interface defined in `b2b-interfaces/air-price-freeze`.
* `ApplePay` - Payments performed through Apple Pay.\n
    Interface defined in `b2bportal-tripadvisor-bff`.
* `Card` - Payments made via Spreedly card api. Allows orders to be purchased with credit or debit cards.\n
    Interface defined in `b2b-interfaces/card`.
* `DisruptionProtectionCredit` - Representation of the exercising of a disruption protection, on a new flight.\n
    Interface defined in `Tysons/server`.
* `HotelPriceFreezeDeposit` - Representation of a discount for purchasing a frozen hotel, amounting to the value of the price freeze.\n
    Interface defined in `Tysons/server`.
* `HotelPriceFreezeExerciseDiscount` - Representation of a discount for purchasing a frozen hotel, amounting to the discount price delta from 
    exercising of the price freeze.\n
    Interface defined in `Tysons/server`.
* `NequiPocketPayment` - Payments via nequi pocket pay. Can only be used for tenant=nequi.\n
    Interface defined in `b2bportal-nequi-bff`.
* `NupayPayment` - Nubank, tenant specific, payment integration. Can only be used for tenant=nubank.\n
    Interface defined in `b2bportal-nubank-bff`.
* `Rewards` - Payments made via Capital One travel rewards. Can only be used for tenant=capone,capone-corporate.\n
    Interface defined in `Tysons/server`
* `TravelWalletCredit` - Representation of travel wallet credits or carror cash, stored in `Scranton`.\n
    Interface defined in `Tysons/server`.
* `TravelWalletOffer` - Representation of any offer sourced from `Scranton`.\n
    Interface defined in `Tysons/server`.
* `UberPayment` - Uber operated payment processor. Can only be used for tenant=uber.\n
    Interface defined in `b2bportal-uber-bff`.
* `Wallet` - Payments performed through `Scranton` wallet.\n
    Interface defined in `b2bportal-tripadvisor-bff`.
 * @export
 * @enum {string}
 */

export const Payment = {
    AirChfarExerciseDiscount: 'AirChfarExerciseDiscount',
    AirPriceFreezeExerciseDiscount: 'AirPriceFreezeExerciseDiscount',
    ApplePay: 'ApplePay',
    Card: 'Card',
    DisruptionProtectionCredit: 'DisruptionProtectionCredit',
    HotelPriceFreezeDeposit: 'HotelPriceFreezeDeposit',
    HotelPriceFreezeExerciseDiscount: 'HotelPriceFreezeExerciseDiscount',
    NequiPocketPayment: 'NequiPocketPayment',
    NupayPayment: 'NupayPayment',
    Rewards: 'Rewards',
    TravelWalletCredit: 'TravelWalletCredit',
    TravelWalletOffer: 'TravelWalletOffer',
    UberPayment: 'UberPayment',
    Wallet: 'Wallet'
} as const;

export type Payment = typeof Payment[keyof typeof Payment];


/**
 * PaymentAuthAction is the supported authentication actions.

* `InteractivePayment3DSAdyenAuthAction` - 3DS auth offered by Adyen
 * @export
 * @enum {string}
 */

export const PaymentAuthAction = {
    InteractivePayment3DSAdyenAuthAction: 'InteractivePayment3DSAdyenAuthAction'
} as const;

export type PaymentAuthAction = typeof PaymentAuthAction[keyof typeof PaymentAuthAction];


/**
 * Model used to generify shared types across any product or payment type. The type of `OpaqueValue`
is a shared value between the FE and BFF. As a result each implementation of the purchase interface
can use different products/payments or even different versions of products or payments.
 * @export
 * @interface PaymentAuthActionOpaqueValue
 */
export interface PaymentAuthActionOpaqueValue {
    'type': PaymentAuthAction;
    'value': any;
}


export interface PaymentError {
    'value': PaymentOpaqueValue;
    'Error': PurchaseErrorEnum;
}


/**
 * A payment id with type

 * `id` - The payment id (if successfully registered)
 * @export
 * @interface PaymentId
 */
export interface PaymentId {
    /**
     * The payment id (if successfully registered)
     * @type {string}
     * @memberof PaymentId
     */
    'id'?: string;
    'payment': Payment;
}


/**
 * Model used to generify shared types across any product or payment type. The type of `OpaqueValue`
is a shared value between the FE and BFF. As a result each implementation of the purchase interface
can use different products/payments or even different versions of products or payments.
 * @export
 * @interface PaymentOpaqueValue
 */
export interface PaymentOpaqueValue {
    'type': Payment;
    'value': any;
}


export interface PolicyCompliance {
    'isInPolicy': boolean;
    'reasons': Array<PolicyComplianceReason>;
}
/**
 * A stated reason for the given PolicyCompliance state
 * @export
 * @enum {string}
 */

export const PolicyComplianceReason = {
    IN_POLICY: 'IN_POLICY',
    TOO_EXPENSIVE: 'TOO_EXPENSIVE',
    UNACCEPTABLE_FARE: 'UNACCEPTABLE_FARE'
} as const;

export type PolicyComplianceReason = typeof PolicyComplianceReason[keyof typeof PolicyComplianceReason];


/**
 * Price in fiat currency as well as any with rewards/account specific currency
 * @export
 * @interface Prices
 */
export interface Prices {
    'fiat': FiatPrice;
    'accountSpecific': { [key: string]: AccountPrice; };
}
/**
 * `Product` types have require shared, known types between client and server. `OpaqueValue`
is used to serialize and deserialize models related to specific `Product`, but avoid coupling
this purchase interface to the specific `Product` implementation.

### Mappings
 * `ShoppedProduct` the model used for quoting the product from shopped state.
 * `QuotedProduct` the model representing the quoted product.
 * `FulfilledProduct` the model representing the fulfilled product.
 * `Error` the model used for communicating errors in the application.

* `AgentFee` - ### Mappings
* `ShoppedProduct` maps to com.hopper.b2b.agentfee.model.AgentFeeScheduleRequest
* `QuotedProduct` maps to com.hopper.b2b.agentfee.model.AgentFee
* `FulfilledProduct` maps to com.hopper.b2b.agentfee.model.AgentFee
* `AirCfar` - todo - WIP / models in b2bportal-uber-bff
* `AirChfar` - todo - WIP / models in b2bportal-uber-bff
* `AirDisruption` - todo - models in b2bportal-uber-bff
* `AirInsurance` - ### Mappings
* `ShoppedProduct` maps to `com.hopper.b2b.insurance.model.air.PurchaseModels.InsuranceQuoteRequest`
* `QuotedProduct` maps to `com.hopper.b2b.insurance.model.air.PurchaseModels.InsuranceQuoteData`
* `FulfilledProduct` maps to `com.hopper.b2b.insurance.model.air.PurchaseModels.FinalizedAirInsurance`
* `Error` maps to `com.hopper.b2b.insurance.model.common.InsuranceError`
* `AirPriceDrop` - ### Mappings
      |* `ShoppedProduct` maps to `com.hopper.b2b.air.pricedrop.model.AirPriceDropQuoteRequest
      |* `QuotedProduct` maps to TBD
      |* `FulfilledProduct` maps to TBD
* `AirPriceFreeze` - ### Mappings
* `ShoppedProduct` maps to `com.hopper.b2b.pricefreeze.model.SchedulePriceQuoteRequest`
* `QuotedProduct` maps to `com.hopper.b2b.pricefreeze.model.PriceQuoteData`
* `FulfilledProduct` maps to `com.hopper.b2b.pricefreeze.model.PriceFreezeFlightPaymentFinalizeResult`
* `Error` maps to `com.hopper.b2b.pricefreeze.model.PriceFreezeError`
* `Flight` - ### V0 Mappings
* `ShoppedProduct` maps to `com.hopper.b2b.air.booking.model.book.FlightBook.SchedulePriceQuoteRequest`
* `QuotedProduct` maps to `com.hopper.b2b.air.booking.model.book.FlightBook.PriceQuoteData`
* `FulfilledProduct` maps to `com.hopper.b2b.air.booking.model.book.FlightBook.PurchaseResult`
* `Error` maps to `com.hopper.b2b.air.booking.model.book.FlightError`

### V1 Mappings
* `ShoppedProduct` maps to `com.hopper.b2b.air.booking.model.book.FlightBook.SchedulePriceQuoteRequest`
* `QuotedProduct` maps to `com.hopper.b2b.air.booking.model.book.FlightBook.QuotedFlight`
* `FulfilledProduct` maps to `com.hopper.b2b.air.booking.model.book.FlightBook.OrderedFlight`
* `Error` maps to `com.hopper.b2b.air.booking.model.book.FlightError`
* `Ground` - ### Mappings
* `ShoppedProduct` maps to `com.hopper.b2b.ground.GroundPriceQuoteScheduleRequest`
* `QuotedProduct` maps to `com.hopper.b2b.ground.GroundPriceQuote`
* `FulfilledProduct` maps to `com.hopper.b2b.ground.GroundBookingResult`
* `Error` maps to com.hopper.b2b.ground.GroundError
* `Homes` - todo - WIP / models in tysons
* `Hotel` - ### Mappings
* `ShoppedProduct` maps to `com.hopper.b2b.model.hotel.book.PriceQuoteScheduleRequest`
* `QuotedProduct` maps to `com.hopper.b2b.model.hotel.book.PriceQuote`
* `FulfilledProduct` maps to `com.hopper.b2b.model.hotel.book.Reservation`
* `Error` maps to ???
* `Incentives` - todo - WIP / models in commbank bff
* Incentives product such as credit lodging and cash back
* `ShoppedProduct` maps to TBD
* `QuotedProduct` maps to TBD
* `FulfilledProduct` maps to TBD
* `LodgingCfar` - todo - WIP / models in tysons
* `LodgingPriceFreeze` - ### Mappings
* `ShoppedProduct` maps to TBD
* `QuotedProduct` maps to TBD
* `FulfilledProduct` maps to TBD
* `MultiProviderFlight` - todo - WIP / models in vi-distribution-b2b
* `Package` - todo - WIP / models in hopper-web bff
* `Seats` - ### V0 Mappings
* `ShoppedProduct` maps to SelectSeatsCommand
* `FulfilledProduct` maps to ???
* `Error` maps to FlightError

### V1 Mappings
* `ShoppedProduct` maps to SelectSeatsRequest
* `FulfilledProduct` maps to ItinerarySeats
* `Error` maps to FlightError
* `VipSupport` - todo - models in b2bportal-uber-bff
 * @export
 * @enum {string}
 */

export const Product = {
    AgentFee: 'AgentFee',
    AirCfar: 'AirCfar',
    AirChfar: 'AirChfar',
    AirDisruption: 'AirDisruption',
    AirInsurance: 'AirInsurance',
    AirPriceDrop: 'AirPriceDrop',
    AirPriceFreeze: 'AirPriceFreeze',
    Flight: 'Flight',
    Ground: 'Ground',
    Homes: 'Homes',
    Hotel: 'Hotel',
    Incentives: 'Incentives',
    LodgingCfar: 'LodgingCfar',
    LodgingPriceFreeze: 'LodgingPriceFreeze',
    MultiProviderFlight: 'MultiProviderFlight',
    Package: 'Package',
    Seats: 'Seats',
    VipSupport: 'VipSupport'
} as const;

export type Product = typeof Product[keyof typeof Product];


export interface ProductError {
    'value': ProductOpaqueValue;
    'Error': PurchaseErrorEnum;
}


/**
 * A product id with type

 * `shoppedProductId` - the shopped product id (if successfully shopped)
 * @export
 * @interface ProductId
 */
export interface ProductId {
    /**
     * the shopped product id (if successfully shopped)
     * @type {string}
     * @memberof ProductId
     */
    'shoppedProductId'?: string;
    'product': Product;
}


/**
 * Model used to generify shared types across any product or payment type. The type of `OpaqueValue`
is a shared value between the FE and BFF. As a result each implementation of the purchase interface
can use different products/payments or even different versions of products or payments.
 * @export
 * @interface ProductOpaqueValue
 */
export interface ProductOpaqueValue {
    'type': Product;
    'value': any;
}


/**
 * @type PurchaseError
 * @export
 */
export type PurchaseError = { Error: 'AuthError' } & AuthError | { Error: 'CartValidationError' } & CartValidationError | { Error: 'ErrorCode' } & ErrorCode | { Error: 'ExpiredFulfillToken' } & ExpiredFulfillToken | { Error: 'ExpiredQuoteToken' } & ExpiredQuoteToken | { Error: 'FraudAutoReject' } & FraudAutoReject | { Error: 'InActivity' } & InActivity | { Error: 'InvalidSession' } & InvalidSession | { Error: 'NoAvailability' } & NoAvailability | { Error: 'NoPaymentsProvided' } & NoPaymentsProvided | { Error: 'NonDistinctPayments' } & NonDistinctPayments | { Error: 'PaymentError' } & PaymentError | { Error: 'ProductError' } & ProductError;

export const PurchaseErrorEnum = {
    AuthError: 'AuthError',
    CartValidationError: 'CartValidationError',
    ErrorCode: 'ErrorCode',
    ExpiredFulfillToken: 'ExpiredFulfillToken',
    ExpiredQuoteToken: 'ExpiredQuoteToken',
    FraudAutoReject: 'FraudAutoReject',
    InActivity: 'InActivity',
    InvalidSession: 'InvalidSession',
    NoAvailability: 'NoAvailability',
    NoPaymentsProvided: 'NoPaymentsProvided',
    NonDistinctPayments: 'NonDistinctPayments',
    PaymentError: 'PaymentError',
    ProductError: 'ProductError'
} as const;

export type PurchaseErrorEnum = typeof PurchaseErrorEnum[keyof typeof PurchaseErrorEnum];


/**
 * Breakdown of a price quote

 * `payments` - List of payments/discounts successfully added to quote
 * `state` - The state of the price quote
 * `products` - List of products successfully added to quote
 * `sellAt` - Original currency/amount used to charge this quote
 * @export
 * @interface QuoteBreakdown
 */
export interface QuoteBreakdown {
    /**
     * List of payments/discounts successfully added to quote
     * @type {Array<QuotedPayment>}
     * @memberof QuoteBreakdown
     */
    'payments': Array<QuotedPayment>;
    'state': QuoteState;
    'productTotal': Prices;
    /**
     * List of products successfully added to quote
     * @type {Array<QuotedProduct>}
     * @memberof QuoteBreakdown
     */
    'products': Array<QuotedProduct>;
    'balance': Prices;
    'paymentTotal': Prices;
    'sellAt'?: Prices;
}


/**
 * A quote breakdown

 * `unavailableProducts` - List of unavailable products that were removed
 * @export
 * @interface QuoteBreakdownResponse
 */
export interface QuoteBreakdownResponse {
    'quoteBreakdown': QuoteBreakdown;
    /**
     * List of unavailable products that were removed
     * @type {Array<FailedProduct>}
     * @memberof QuoteBreakdownResponse
     */
    'unavailableProducts': Array<FailedProduct>;
}
export interface QuoteFailure {
    'errors': Array<PurchaseError>;
    'QuoteResponse': QuoteResponseEnum;
}


export interface QuoteFailureV0 {
    'errors': Array<PurchaseError>;
    'QuoteResponse': QuoteResponseV0Enum;
}


export interface QuotePending {
    'QuoteResponse': QuoteResponseEnum;
}


export interface QuotePendingV0 {
    'QuoteResponse': QuoteResponseV0Enum;
}


export interface QuoteRequest {
    /**
     * An email address that matches given regex pattern. The frontend should validate the emails address since the request will fail if it doesn't match the pattern
     * @type {string}
     * @memberof QuoteRequest
     */
    'emailAddress': string;
    'products': Array<ProductOpaqueValue>;
}
export interface QuoteRequestV0 {
    /**
     * An email address that matches given regex pattern. The frontend should validate the emails address since the request will fail if it doesn't match the pattern
     * @type {string}
     * @memberof QuoteRequestV0
     */
    'emailAddress': string;
    'request': ProductOpaqueValue;
}
/**
 * @type QuoteResponse
 * @export
 */
export type QuoteResponse = { QuoteResponse: 'Failure' } & QuoteFailure | { QuoteResponse: 'Pending' } & QuotePending | { QuoteResponse: 'Success' } & QuoteSuccess;

export const QuoteResponseEnum = {
    Failure: 'Failure',
    Pending: 'Pending',
    Success: 'Success'
} as const;

export type QuoteResponseEnum = typeof QuoteResponseEnum[keyof typeof QuoteResponseEnum];


/**
 * @type QuoteResponseV0
 * @export
 */
export type QuoteResponseV0 = { QuoteResponse: 'Failure' } & QuoteFailureV0 | { QuoteResponse: 'Pending' } & QuotePendingV0 | { QuoteResponse: 'Success' } & QuoteSuccessV0;

export const QuoteResponseV0Enum = {
    Failure: 'Failure',
    Pending: 'Pending',
    Success: 'Success'
} as const;

export type QuoteResponseV0Enum = typeof QuoteResponseV0Enum[keyof typeof QuoteResponseV0Enum];


/**
 * The state of the price quote
 * @export
 * @enum {string}
 */

export const QuoteState = {
    Empty: 'Empty',
    Fulfillable: 'Fulfillable',
    Fulfilled: 'Fulfilled',
    Unavailable: 'Unavailable',
    Unbalanced: 'Unbalanced'
} as const;

export type QuoteState = typeof QuoteState[keyof typeof QuoteState];


/**
 * `failedProductAdds` - List of products that failed to be added to quote and were removed
 * @export
 * @interface QuoteSuccess
 */
export interface QuoteSuccess {
    'quoteBreakdown': QuoteBreakdown;
    /**
     * List of products that failed to be added to quote and were removed
     * @type {Array<FailedProduct>}
     * @memberof QuoteSuccess
     */
    'failedProductAdds': Array<FailedProduct>;
    'trackingProperties': TrackingProperties;
    'QuoteResponse': QuoteResponseEnum;
}


export interface QuoteSuccessV0 {
    'quote': ProductOpaqueValue;
    'QuoteResponse': QuoteResponseV0Enum;
}


/**
 * Details on a payment added to a quote
 * @export
 * @interface QuotedPayment
 */
export interface QuotedPayment {
    'id': string;
    'payment': PaymentOpaqueValue;
}
/**
 * Details on a product added to a quote
 * @export
 * @interface QuotedProduct
 */
export interface QuotedProduct {
    'shoppedProductId': string;
    'product': ProductOpaqueValue;
    'corporateTravel'?: CorporateTravel;
}
/**
 * List of payments ids to remove from quote. Currently not supported.
 * @export
 * @interface RemovePaymentsRequest
 */
export interface RemovePaymentsRequest {
    'payments': Array<PaymentId>;
}
/**
 * List of product ids to remove from quote
 * @export
 * @interface RemoveProductsRequest
 */
export interface RemoveProductsRequest {
    'products': Array<ProductId>;
}
export interface Success {
    'CompleteInteractiveAuthResponse': CompleteInteractiveAuthResponseEnum;
}


export interface TrackingProperties {
    'properties'?: any;
    'encryptedProperties'?: string;
}
/**
 * Trip was found. The `tripAccessToken` can be used view booking details and access post-booking operations on the booking

 * `id` - The identifier for the booking (e.g. the itinerary id).
 * `tripAccessToken` - A token that gives access to post-booking opperations on a particur booking. The token should be passed on header of post-booking endpoints.
 * @export
 * @interface TripFound
 */
export interface TripFound {
    /**
     * The identifier for the booking (e.g. the itinerary id).
     * @type {string}
     * @memberof TripFound
     */
    'id': string;
    'tripAccessToken': CipherText;
    'GetTripAccessTokenResponse': GetTripAccessTokenResponseEnum;
}


/**
 * @type TripKey
 * A key used to look up a booking
 * @export
 */
export type TripKey = { TripKey: 'ByLastNameAndConfirmationId' } & ByLastNameAndConfirmationId;

export const TripKeyEnum = {
    ByLastNameAndConfirmationId: 'ByLastNameAndConfirmationId'
} as const;

export type TripKeyEnum = typeof TripKeyEnum[keyof typeof TripKeyEnum];


/**
 * Trip was not found
 * @export
 * @interface TripNotFound
 */
export interface TripNotFound {
    'GetTripAccessTokenResponse': GetTripAccessTokenResponseEnum;
}


/**
 * A request to add/remove a product/payment on a quote
 * @export
 * @interface UpdateQuoteRequest
 */
export interface UpdateQuoteRequest {
    'addProducts'?: AddProductsRequest;
    'token': CipherText;
    'removeProducts'?: RemoveProductsRequest;
    'removePayments'?: RemovePaymentsRequest;
    'addPayments'?: AddPaymentsRequest;
}
/**
 * The result of updating a quote

 * `failedProductAdds` - List of products that failed to be added to quote and were removed
 * `failedPaymentAdds` - List of payments that failed to be added to quote and were removed
 * `failedProductRemoves` - List of products that failed to be removed from the quote
 * `failedPaymentRemoves` - List of payments that failed to be added to be removed from the quote
 * @export
 * @interface UpdateQuoteResponse
 */
export interface UpdateQuoteResponse {
    /**
     * List of products that failed to be added to quote and were removed
     * @type {Array<FailedProduct>}
     * @memberof UpdateQuoteResponse
     */
    'failedProductAdds': Array<FailedProduct>;
    /**
     * List of payments that failed to be added to quote and were removed
     * @type {Array<FailedPayment>}
     * @memberof UpdateQuoteResponse
     */
    'failedPaymentAdds': Array<FailedPayment>;
    /**
     * List of products that failed to be removed from the quote
     * @type {Array<FailedProduct>}
     * @memberof UpdateQuoteResponse
     */
    'failedProductRemoves': Array<FailedProduct>;
    /**
     * List of payments that failed to be added to be removed from the quote
     * @type {Array<FailedPayment>}
     * @memberof UpdateQuoteResponse
     */
    'failedPaymentRemoves': Array<FailedPayment>;
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get an access token for a trip by entering last name and an external id for a product like a flight locator
         * @param {GetTripAccessTokenRequest} getTripAccessTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MyTripAccessTokenPut: async (getTripAccessTokenRequest: GetTripAccessTokenRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getTripAccessTokenRequest' is not null or undefined
            assertParamExists('apiV0MyTripAccessTokenPut', 'getTripAccessTokenRequest', getTripAccessTokenRequest)
            const localVarPath = `/api/v0/myTrip/accessToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getTripAccessTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtain the finalized puchased product. Idempotent.
         * @param {CipherText} cipherText 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PurchaseFulfillPollPost: async (cipherText: CipherText, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cipherText' is not null or undefined
            assertParamExists('apiV0PurchaseFulfillPollPost', 'cipherText', cipherText)
            const localVarPath = `/api/v0/purchase/fulfill/poll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cipherText, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Finalize the purchasing of an existing quote. Non-idempotent.
         * @param {FulfillRequestV0} fulfillRequestV0 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PurchaseFulfillSchedulePost: async (fulfillRequestV0: FulfillRequestV0, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fulfillRequestV0' is not null or undefined
            assertParamExists('apiV0PurchaseFulfillSchedulePost', 'fulfillRequestV0', fulfillRequestV0)
            const localVarPath = `/api/v0/purchase/fulfill/schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fulfillRequestV0, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Release a quote, so it is no longer usable. Non-idempotent.
         * @param {CipherText} cipherText 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PurchaseQuoteDiscardPost: async (cipherText: CipherText, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cipherText' is not null or undefined
            assertParamExists('apiV0PurchaseQuoteDiscardPost', 'cipherText', cipherText)
            const localVarPath = `/api/v0/purchase/quote/discard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cipherText, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtain quote on list of products. Idempotent.
         * @param {CipherText} cipherText 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PurchaseQuotePollPost: async (cipherText: CipherText, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cipherText' is not null or undefined
            assertParamExists('apiV0PurchaseQuotePollPost', 'cipherText', cipherText)
            const localVarPath = `/api/v0/purchase/quote/poll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cipherText, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Initialize a price quote on specified products. Non-idempotent.
         * @param {QuoteRequestV0} quoteRequestV0 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PurchaseQuoteSchedulePost: async (quoteRequestV0: QuoteRequestV0, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quoteRequestV0' is not null or undefined
            assertParamExists('apiV0PurchaseQuoteSchedulePost', 'quoteRequestV0', quoteRequestV0)
            const localVarPath = `/api/v0/purchase/quote/schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(quoteRequestV0, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Complete interactive payment authorisation by sending back the challenge result.
         * @param {CompleteInteractiveAuthRequest} completeInteractiveAuthRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseFulfillCompleteInteractiveAuthPut: async (completeInteractiveAuthRequest: CompleteInteractiveAuthRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'completeInteractiveAuthRequest' is not null or undefined
            assertParamExists('apiV1PurchaseFulfillCompleteInteractiveAuthPut', 'completeInteractiveAuthRequest', completeInteractiveAuthRequest)
            const localVarPath = `/api/v1/purchase/fulfill/completeInteractiveAuth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeInteractiveAuthRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtain the finalized puchased product. Idempotent.
         * @param {CipherText} cipherText 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseFulfillPollPut: async (cipherText: CipherText, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cipherText' is not null or undefined
            assertParamExists('apiV1PurchaseFulfillPollPut', 'cipherText', cipherText)
            const localVarPath = `/api/v1/purchase/fulfill/poll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cipherText, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Finalize the purchasing of an existing quote. Non-idempotent.
         * @param {FulfillRequest} fulfillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseFulfillSchedulePost: async (fulfillRequest: FulfillRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fulfillRequest' is not null or undefined
            assertParamExists('apiV1PurchaseFulfillSchedulePost', 'fulfillRequest', fulfillRequest)
            const localVarPath = `/api/v1/purchase/fulfill/schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fulfillRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get breakdown of quoted products and payments. Idempotent.
         * @param {CipherText} cipherText 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseQuoteBreakdownPut: async (cipherText: CipherText, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cipherText' is not null or undefined
            assertParamExists('apiV1PurchaseQuoteBreakdownPut', 'cipherText', cipherText)
            const localVarPath = `/api/v1/purchase/quote/breakdown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cipherText, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Release a quote, so it is no longer usable. Non-idempotent.
         * @param {CipherText} cipherText 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseQuoteDiscardPost: async (cipherText: CipherText, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cipherText' is not null or undefined
            assertParamExists('apiV1PurchaseQuoteDiscardPost', 'cipherText', cipherText)
            const localVarPath = `/api/v1/purchase/quote/discard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cipherText, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtain quote on list of products. Idempotent
         * @param {CipherText} cipherText 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseQuotePollPut: async (cipherText: CipherText, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cipherText' is not null or undefined
            assertParamExists('apiV1PurchaseQuotePollPut', 'cipherText', cipherText)
            const localVarPath = `/api/v1/purchase/quote/poll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cipherText, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Initialize a price quote on specified products. Non-idempotent.
         * @param {QuoteRequest} quoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseQuoteSchedulePost: async (quoteRequest: QuoteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quoteRequest' is not null or undefined
            assertParamExists('apiV1PurchaseQuoteSchedulePost', 'quoteRequest', quoteRequest)
            const localVarPath = `/api/v1/purchase/quote/schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(quoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update products or payments in quote. Non-idempotent
         * @param {UpdateQuoteRequest} updateQuoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseQuoteUpdatePost: async (updateQuoteRequest: UpdateQuoteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateQuoteRequest' is not null or undefined
            assertParamExists('apiV1PurchaseQuoteUpdatePost', 'updateQuoteRequest', updateQuoteRequest)
            const localVarPath = `/api/v1/purchase/quote/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateQuoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Get an access token for a trip by entering last name and an external id for a product like a flight locator
         * @param {GetTripAccessTokenRequest} getTripAccessTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0MyTripAccessTokenPut(getTripAccessTokenRequest: GetTripAccessTokenRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTripAccessTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0MyTripAccessTokenPut(getTripAccessTokenRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtain the finalized puchased product. Idempotent.
         * @param {CipherText} cipherText 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0PurchaseFulfillPollPost(cipherText: CipherText, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FulfillResponseV0>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0PurchaseFulfillPollPost(cipherText, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Finalize the purchasing of an existing quote. Non-idempotent.
         * @param {FulfillRequestV0} fulfillRequestV0 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0PurchaseFulfillSchedulePost(fulfillRequestV0: FulfillRequestV0, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CipherText>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0PurchaseFulfillSchedulePost(fulfillRequestV0, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Release a quote, so it is no longer usable. Non-idempotent.
         * @param {CipherText} cipherText 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0PurchaseQuoteDiscardPost(cipherText: CipherText, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0PurchaseQuoteDiscardPost(cipherText, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtain quote on list of products. Idempotent.
         * @param {CipherText} cipherText 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0PurchaseQuotePollPost(cipherText: CipherText, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuoteResponseV0>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0PurchaseQuotePollPost(cipherText, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Initialize a price quote on specified products. Non-idempotent.
         * @param {QuoteRequestV0} quoteRequestV0 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0PurchaseQuoteSchedulePost(quoteRequestV0: QuoteRequestV0, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CipherText>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0PurchaseQuoteSchedulePost(quoteRequestV0, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Complete interactive payment authorisation by sending back the challenge result.
         * @param {CompleteInteractiveAuthRequest} completeInteractiveAuthRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PurchaseFulfillCompleteInteractiveAuthPut(completeInteractiveAuthRequest: CompleteInteractiveAuthRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompleteInteractiveAuthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PurchaseFulfillCompleteInteractiveAuthPut(completeInteractiveAuthRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtain the finalized puchased product. Idempotent.
         * @param {CipherText} cipherText 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PurchaseFulfillPollPut(cipherText: CipherText, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FulfillResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PurchaseFulfillPollPut(cipherText, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Finalize the purchasing of an existing quote. Non-idempotent.
         * @param {FulfillRequest} fulfillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PurchaseFulfillSchedulePost(fulfillRequest: FulfillRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CipherText>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PurchaseFulfillSchedulePost(fulfillRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get breakdown of quoted products and payments. Idempotent.
         * @param {CipherText} cipherText 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PurchaseQuoteBreakdownPut(cipherText: CipherText, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuoteBreakdownResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PurchaseQuoteBreakdownPut(cipherText, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Release a quote, so it is no longer usable. Non-idempotent.
         * @param {CipherText} cipherText 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PurchaseQuoteDiscardPost(cipherText: CipherText, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PurchaseQuoteDiscardPost(cipherText, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Obtain quote on list of products. Idempotent
         * @param {CipherText} cipherText 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PurchaseQuotePollPut(cipherText: CipherText, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuoteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PurchaseQuotePollPut(cipherText, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Initialize a price quote on specified products. Non-idempotent.
         * @param {QuoteRequest} quoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PurchaseQuoteSchedulePost(quoteRequest: QuoteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CipherText>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PurchaseQuoteSchedulePost(quoteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update products or payments in quote. Non-idempotent
         * @param {UpdateQuoteRequest} updateQuoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PurchaseQuoteUpdatePost(updateQuoteRequest: UpdateQuoteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateQuoteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PurchaseQuoteUpdatePost(updateQuoteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Get an access token for a trip by entering last name and an external id for a product like a flight locator
         * @param {GetTripAccessTokenRequest} getTripAccessTokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MyTripAccessTokenPut(getTripAccessTokenRequest: GetTripAccessTokenRequest, options?: any): AxiosPromise<GetTripAccessTokenResponse> {
            return localVarFp.apiV0MyTripAccessTokenPut(getTripAccessTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtain the finalized puchased product. Idempotent.
         * @param {CipherText} cipherText 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PurchaseFulfillPollPost(cipherText: CipherText, options?: any): AxiosPromise<FulfillResponseV0> {
            return localVarFp.apiV0PurchaseFulfillPollPost(cipherText, options).then((request) => request(axios, basePath));
        },
        /**
         * Finalize the purchasing of an existing quote. Non-idempotent.
         * @param {FulfillRequestV0} fulfillRequestV0 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PurchaseFulfillSchedulePost(fulfillRequestV0: FulfillRequestV0, options?: any): AxiosPromise<CipherText> {
            return localVarFp.apiV0PurchaseFulfillSchedulePost(fulfillRequestV0, options).then((request) => request(axios, basePath));
        },
        /**
         * Release a quote, so it is no longer usable. Non-idempotent.
         * @param {CipherText} cipherText 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PurchaseQuoteDiscardPost(cipherText: CipherText, options?: any): AxiosPromise<any> {
            return localVarFp.apiV0PurchaseQuoteDiscardPost(cipherText, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtain quote on list of products. Idempotent.
         * @param {CipherText} cipherText 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PurchaseQuotePollPost(cipherText: CipherText, options?: any): AxiosPromise<QuoteResponseV0> {
            return localVarFp.apiV0PurchaseQuotePollPost(cipherText, options).then((request) => request(axios, basePath));
        },
        /**
         * Initialize a price quote on specified products. Non-idempotent.
         * @param {QuoteRequestV0} quoteRequestV0 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PurchaseQuoteSchedulePost(quoteRequestV0: QuoteRequestV0, options?: any): AxiosPromise<CipherText> {
            return localVarFp.apiV0PurchaseQuoteSchedulePost(quoteRequestV0, options).then((request) => request(axios, basePath));
        },
        /**
         * Complete interactive payment authorisation by sending back the challenge result.
         * @param {CompleteInteractiveAuthRequest} completeInteractiveAuthRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseFulfillCompleteInteractiveAuthPut(completeInteractiveAuthRequest: CompleteInteractiveAuthRequest, options?: any): AxiosPromise<CompleteInteractiveAuthResponse> {
            return localVarFp.apiV1PurchaseFulfillCompleteInteractiveAuthPut(completeInteractiveAuthRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtain the finalized puchased product. Idempotent.
         * @param {CipherText} cipherText 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseFulfillPollPut(cipherText: CipherText, options?: any): AxiosPromise<FulfillResponse> {
            return localVarFp.apiV1PurchaseFulfillPollPut(cipherText, options).then((request) => request(axios, basePath));
        },
        /**
         * Finalize the purchasing of an existing quote. Non-idempotent.
         * @param {FulfillRequest} fulfillRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseFulfillSchedulePost(fulfillRequest: FulfillRequest, options?: any): AxiosPromise<CipherText> {
            return localVarFp.apiV1PurchaseFulfillSchedulePost(fulfillRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get breakdown of quoted products and payments. Idempotent.
         * @param {CipherText} cipherText 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseQuoteBreakdownPut(cipherText: CipherText, options?: any): AxiosPromise<QuoteBreakdownResponse> {
            return localVarFp.apiV1PurchaseQuoteBreakdownPut(cipherText, options).then((request) => request(axios, basePath));
        },
        /**
         * Release a quote, so it is no longer usable. Non-idempotent.
         * @param {CipherText} cipherText 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseQuoteDiscardPost(cipherText: CipherText, options?: any): AxiosPromise<any> {
            return localVarFp.apiV1PurchaseQuoteDiscardPost(cipherText, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtain quote on list of products. Idempotent
         * @param {CipherText} cipherText 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseQuotePollPut(cipherText: CipherText, options?: any): AxiosPromise<QuoteResponse> {
            return localVarFp.apiV1PurchaseQuotePollPut(cipherText, options).then((request) => request(axios, basePath));
        },
        /**
         * Initialize a price quote on specified products. Non-idempotent.
         * @param {QuoteRequest} quoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseQuoteSchedulePost(quoteRequest: QuoteRequest, options?: any): AxiosPromise<CipherText> {
            return localVarFp.apiV1PurchaseQuoteSchedulePost(quoteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update products or payments in quote. Non-idempotent
         * @param {UpdateQuoteRequest} updateQuoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PurchaseQuoteUpdatePost(updateQuoteRequest: UpdateQuoteRequest, options?: any): AxiosPromise<UpdateQuoteResponse> {
            return localVarFp.apiV1PurchaseQuoteUpdatePost(updateQuoteRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * Get an access token for a trip by entering last name and an external id for a product like a flight locator
     * @param {GetTripAccessTokenRequest} getTripAccessTokenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0MyTripAccessTokenPut(getTripAccessTokenRequest: GetTripAccessTokenRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0MyTripAccessTokenPut(getTripAccessTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtain the finalized puchased product. Idempotent.
     * @param {CipherText} cipherText 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0PurchaseFulfillPollPost(cipherText: CipherText, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0PurchaseFulfillPollPost(cipherText, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Finalize the purchasing of an existing quote. Non-idempotent.
     * @param {FulfillRequestV0} fulfillRequestV0 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0PurchaseFulfillSchedulePost(fulfillRequestV0: FulfillRequestV0, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0PurchaseFulfillSchedulePost(fulfillRequestV0, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Release a quote, so it is no longer usable. Non-idempotent.
     * @param {CipherText} cipherText 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0PurchaseQuoteDiscardPost(cipherText: CipherText, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0PurchaseQuoteDiscardPost(cipherText, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtain quote on list of products. Idempotent.
     * @param {CipherText} cipherText 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0PurchaseQuotePollPost(cipherText: CipherText, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0PurchaseQuotePollPost(cipherText, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Initialize a price quote on specified products. Non-idempotent.
     * @param {QuoteRequestV0} quoteRequestV0 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0PurchaseQuoteSchedulePost(quoteRequestV0: QuoteRequestV0, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0PurchaseQuoteSchedulePost(quoteRequestV0, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Complete interactive payment authorisation by sending back the challenge result.
     * @param {CompleteInteractiveAuthRequest} completeInteractiveAuthRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV1PurchaseFulfillCompleteInteractiveAuthPut(completeInteractiveAuthRequest: CompleteInteractiveAuthRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV1PurchaseFulfillCompleteInteractiveAuthPut(completeInteractiveAuthRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtain the finalized puchased product. Idempotent.
     * @param {CipherText} cipherText 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV1PurchaseFulfillPollPut(cipherText: CipherText, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV1PurchaseFulfillPollPut(cipherText, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Finalize the purchasing of an existing quote. Non-idempotent.
     * @param {FulfillRequest} fulfillRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV1PurchaseFulfillSchedulePost(fulfillRequest: FulfillRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV1PurchaseFulfillSchedulePost(fulfillRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get breakdown of quoted products and payments. Idempotent.
     * @param {CipherText} cipherText 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV1PurchaseQuoteBreakdownPut(cipherText: CipherText, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV1PurchaseQuoteBreakdownPut(cipherText, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Release a quote, so it is no longer usable. Non-idempotent.
     * @param {CipherText} cipherText 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV1PurchaseQuoteDiscardPost(cipherText: CipherText, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV1PurchaseQuoteDiscardPost(cipherText, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtain quote on list of products. Idempotent
     * @param {CipherText} cipherText 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV1PurchaseQuotePollPut(cipherText: CipherText, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV1PurchaseQuotePollPut(cipherText, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Initialize a price quote on specified products. Non-idempotent.
     * @param {QuoteRequest} quoteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV1PurchaseQuoteSchedulePost(quoteRequest: QuoteRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV1PurchaseQuoteSchedulePost(quoteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update products or payments in quote. Non-idempotent
     * @param {UpdateQuoteRequest} updateQuoteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV1PurchaseQuoteUpdatePost(updateQuoteRequest: UpdateQuoteRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV1PurchaseQuoteUpdatePost(updateQuoteRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



